import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const isModelShown = atom<boolean>({
    key: 'isModelShown',
    default: false,
});

export const useIsModelShownValue = () => useRecoilValue(isModelShown);
export const useIsModelShownSetState = () => useSetRecoilState(isModelShown);
